module.exports = __webpack_public_path__ + "img/upload.af0981368367c8cf46c7351b60a47760.af098136.png";